function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.34,290.73,301,294.58c1.23.32,3.65-1.73,3.54-3L301.05,251a3.87,3.87,0,0,0-2.89-3.42l-12.87-2.8c-1.23-.31-4.32,1.16-4.21,2.42l5.36,40.11A3.87,3.87,0,0,0,289.34,290.73Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198,422a18.09,18.09,0,0,0-35.61,4.47A18.36,18.36,0,0,0,163,431a18.12,18.12,0,0,0,17.49,13.6,18.44,18.44,0,0,0,4.53-.57,18,18,0,0,0,7.85-4.3,7.45,7.45,0,0,1-.49-.87v0a17.08,17.08,0,0,1-20.13,2.61l-.42-.23A17.08,17.08,0,0,1,176.27,410a17.09,17.09,0,0,1,21.15,19.08,7.36,7.36,0,0,1,1-.11A18,18,0,0,0,198,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.37,438.89a23.41,23.41,0,0,1-6.14,4.21,9.32,9.32,0,0,1-1.34.47,9.22,9.22,0,0,1-1.41.24c-5,.52-11.69-2-11.69-2l.44-.33a22.48,22.48,0,0,1,4-2.51c1-.27,2.79-1.52,2-4.22a16.5,16.5,0,0,1-5.74-9.38c-.62-2.74-2-8.05,3.57-10.26h0a13.64,13.64,0,0,1,1.36-.43c.48-.12.95-.21,1.39-.28v0c6-.76,7.29,4.57,8.07,7.26a16.53,16.53,0,0,1-.52,11c.62,2.74,2.76,3,3.79,2.73a6.64,6.64,0,0,1,1.51-.05,7,7,0,0,0,.2,2.31,7.07,7.07,0,0,0,.44,1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,443.36a7.45,7.45,0,1,1,7.22-9.3h0a7.47,7.47,0,0,1-7.22,9.3Zm0-13.9a6.3,6.3,0,0,0-1.61.21,6.35,6.35,0,1,0,1.61-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21,435.61,197,432.75l1.63-.42.29,3.1,2.35-2.05.9,1.41-2.83,1.27,2.66,1.57-1.06,1.3-2.08-2.32-.71,3-1.54-.62,1.57-2.66-3.1.25.11-1.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06,414.8c-5.13-5.62-8.93-1.45-8.93-1.45s-5.33-1.83-7.13,5.57,3.44,13.21-1,15.66c0,0,5.64,2.4,13.66.34s11.81-6.87,11.81-6.87C189.41,428,191.2,420.41,186.06,414.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.74,250.58a12.41,12.41,0,0,0-23.11-8.45,12.83,12.83,0,0,0-1.07,2.93A12.4,12.4,0,0,0,462,259.76a5.08,5.08,0,0,1,0-.68s0,0,0,0a11.79,11.79,0,0,1-6,.19,11.58,11.58,0,0,1-7.13-4.92,2.75,2.75,0,0,1-.19-.28,11.62,11.62,0,0,1-1.63-4.26,12,12,0,0,1,.13-4.58,11.72,11.72,0,0,1,14-8.8,11.79,11.79,0,0,1,2.78,1,11.72,11.72,0,0,1,4.12,17.27,4.42,4.42,0,0,1,.67.25A12.35,12.35,0,0,0,470.74,250.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,259.08a16.17,16.17,0,0,1-5.06.64,7.3,7.3,0,0,1-1-.14,6.64,6.64,0,0,1-.93-.29c-3.2-1.25-6.5-4.9-6.5-4.9l.38-.06a14.84,14.84,0,0,1,3.25-.26,2.16,2.16,0,0,0,2.55-1.95,11.32,11.32,0,0,1-.56-7.52c.49-1.86,1.29-5.54,5.4-5.13h0a9.6,9.6,0,0,1,1,.16q.5.12.93.27h0c3.88,1.41,3,5.08,2.64,7a11.36,11.36,0,0,1-3.76,6.54,2.13,2.13,0,0,0,1.45,2.85,4.48,4.48,0,0,1,.93.44,5,5,0,0,0-.6,1.47,4.51,4.51,0,0,0-.11.89S462,259.07,462,259.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.42,263.77a5.16,5.16,0,0,1-2-1.82,5.11,5.11,0,1,1,9.3-1.58h0a5.09,5.09,0,0,1-6.11,3.84A5,5,0,0,1,464.42,263.77Zm4.38-8.46a4.72,4.72,0,0,0-1.05-.39,4.42,4.42,0,1,0,1.37,8.06,4.42,4.42,0,0,0,1.39-6.1A4.37,4.37,0,0,0,468.8,255.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.59,258.91l.15-2.13,1.12.25-.8,2,2.08-.51.11,1.14-2.13-.12,1.13,1.8-1.05.45-.54-2.07-1.39,1.63-.74-.86,1.79-1.13-2-.82.6-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.72,242.41c-1.36-5-5-3.69-5-3.69s-2.67-2.78-6.09,1.16-2.05,9.13-5.53,9.24a17.22,17.22,0,0,0,17.58,4C463.61,251.53,467.09,247.45,465.72,242.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,80.31a18.08,18.08,0,1,0-25.22,13.5,18.43,18.43,0,0,0,4.37,1.32,18.05,18.05,0,0,0,8.92-.73,8.47,8.47,0,0,1-.1-1s0,0,0,0a17.07,17.07,0,0,1-19.45-5.81c-.1-.12-.2-.25-.29-.38a17.19,17.19,0,0,1-2.74-6.08,17.37,17.37,0,0,1-.18-6.67,17.09,17.09,0,0,1,19.71-14,16.67,16.67,0,0,1,4.12,1.24,17.1,17.1,0,0,1,7.43,24.8,7.64,7.64,0,0,1,1,.32A18.1,18.1,0,0,0,335.13,80.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,93.4a23.37,23.37,0,0,1-7.32,1.35,9,9,0,0,1-1.41-.12,8.84,8.84,0,0,1-1.39-.35c-4.76-1.55-9.86-6.6-9.86-6.6l.54-.12a23,23,0,0,1,4.71-.65c1.05.18,3.17-.25,3.55-3A16.5,16.5,0,0,1,310.5,73c.55-2.75,1.42-8.18,7.43-7.92h0a12.86,12.86,0,0,1,1.42.16,13.34,13.34,0,0,1,1.38.31v0c5.76,1.73,4.8,7.14,4.42,9.91a16.52,16.52,0,0,1-5,9.83c-.55,2.76,1.3,3.86,2.35,4a6.35,6.35,0,0,1,1.4.57,6.78,6.78,0,0,0-.76,2.19,7.06,7.06,0,0,0-.09,1.29S323.11,93.39,323.1,93.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,100a7.46,7.46,0,0,1-1.27-12.88,7.45,7.45,0,0,1,11.66,7.32h0a7.46,7.46,0,0,1-8.59,6.1A7.81,7.81,0,0,1,327,100Zm5.68-12.69a6.27,6.27,0,0,0-1.56-.47,6.42,6.42,0,1,0,1.56.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,92.78l0-3.12,1.65.28-1,3,3-.92.25,1.66h-3.11l1.79,2.52-1.49.75-1-3-1.88,2.48-1.16-1.2,2.52-1.79-2.93-1,.78-1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.64,
    y: 60.98,
    width: 32.42,
    height: 21.14,
    rx: 1.9,
    transform: "translate(-9.22 31.01) rotate(-9.41)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54,66.27,182,73a3.83,3.83,0,0,0,4.12-.69L198.52,61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,79.94l6.8-5.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.87,75.64l-8.2-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.58,
    y: 408.39,
    width: 32.42,
    height: 21.14,
    rx: 1.9,
    transform: "matrix(0.86, 0.5, -0.5, 0.86, 251.34, -93.44)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,403.86l7.59,15A3.83,3.83,0,0,0,300,421l16.82-.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22,417.81l8.72.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,431.06l-4.42-7.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.11,
    y: 297.4,
    width: 32.42,
    height: 21.14,
    rx: 1.9,
    transform: "translate(-140.74 58.41) rotate(-28.34)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.23,308.58,44,310a3.85,3.85,0,0,0,3.67-2l8.08-14.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,319.79l4.66-7.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,307.29l-8.72-.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.55,113.87V395.92a2.87,2.87,0,0,0,2.86,2.87h171.5a2.87,2.87,0,0,0,2.87-2.87v-282a6.56,6.56,0,0,0-6.54-6.54H204.39a3.68,3.68,0,0,0-3.52,2.63,3.64,3.64,0,0,1-1.32,1.9,3.7,3.7,0,0,1-2.2.73H129a3.67,3.67,0,0,1-3.52-2.63,3.6,3.6,0,0,0-1.33-1.9,3.7,3.7,0,0,0-2.2-.73H81.09A6.56,6.56,0,0,0,74.55,113.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.55,
    y: 130.14,
    width: 177.23,
    height: 35.3,
    transform: "translate(326.33 295.59) rotate(180)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.55,
    y: 165.44,
    width: 177.23,
    height: 196.95,
    transform: "translate(326.33 527.84) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.44,
    y: 372.08,
    width: 12.13,
    height: 12.13,
    rx: 3.3,
    transform: "translate(331.01 756.29) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.38,
    y1: 142.78,
    x2: 84.68,
    y2: 142.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.38,
    y1: 147.56,
    x2: 84.68,
    y2: 147.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.38,
    y1: 152.34,
    x2: 84.68,
    y2: 152.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,185.48H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h29.28a2,2,0,0,1,2,2h0A2,2,0,0,1,147.32,185.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,190.39H117.12a1.05,1.05,0,0,1-1.06-1.06h0a1.05,1.05,0,0,1,1.06-1.05H218.79a1,1,0,0,1,1.05,1.05h0A1.05,1.05,0,0,1,218.79,190.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.91,
    cy: 186.28,
    r: 10.88,
    transform: "translate(-100.01 116.19) rotate(-42.62)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,197.08h0c3.06-.45,6.7-3,6.7-3a17.46,17.46,0,0,0-3.13-1,1.93,1.93,0,0,1-1.85-2.22,10.19,10.19,0,0,0,2-6.5c-.05-1.74,0-5.13-3.72-5.6h0c-.28,0-.57,0-.88,0h0c-.31,0-.6,0-.88,0h0c-3.69.47-3.66,3.86-3.72,5.6a10.19,10.19,0,0,0,2,6.5,1.93,1.93,0,0,1-1.85,2.22,17.31,17.31,0,0,0-3.12,1s3.63,2.55,6.69,3h0a5.43,5.43,0,0,0,.88.08h0a5.33,5.33,0,0,0,.88-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.34,
    cy: 194.69,
    r: 4.3,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,194.44l-.3-1.91h1l-.3,1.91,1.72-.87.32,1-1.89.33,1.35,1.35-.83.61-.89-1.71-.89,1.71-.83-.61,1.35-1.35-1.9-.33.33-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,180.1c-2.21-4.15-5.13-2.24-5.13-2.24S96,176,93.78,180.1s0,8.45-3,9.23a15.46,15.46,0,0,0,16.26,0C104,188.55,106.25,184.25,104,180.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.86,
    y: 122.27,
    width: 1.98,
    height: 4.04,
    transform: "translate(203.7 248.59) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.22,
    y: 120.64,
    width: 1.98,
    height: 5.68,
    transform: "translate(196.42 246.95) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.58,
    y: 119,
    width: 1.98,
    height: 7.31,
    transform: "translate(189.15 245.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.94,
    y: 117.37,
    width: 1.98,
    height: 8.94,
    transform: "translate(181.87 243.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 118.19,
    width: 13.04,
    height: 7.31,
    rx: 1.19,
    transform: "translate(466.64 243.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,119.72h1a1,1,0,0,1,1,1V123a1,1,0,0,1-1,1h-1a0,0,0,0,1,0,0v-4.25A0,0,0,0,1,223.27,119.72Z",
    transform: "translate(448.55 243.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,142.8a4.39,4.39,0,1,1-6.21,0A4.38,4.38,0,0,1,239.68,142.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.68,
    y1: 149.01,
    x2: 244.29,
    y2: 153.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.47,
    y: 139.63,
    width: 24.33,
    height: 15.87,
    rx: 1.9,
    style: {
      fill: "#263238",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,141.53l10.6,6.89a2.91,2.91,0,0,0,3.13,0l10.6-6.89",
    style: {
      fill: "#263238",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,152.32l5.71-3.21",
    style: {
      fill: "#263238",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.52,152.32l-5.7-3.21",
    style: {
      fill: "#263238",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32,220.34H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h19.28a2,2,0,0,1,2,2h0A2,2,0,0,1,137.32,220.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79,225.26H117.12a1.06,1.06,0,0,1-1.06-1.06h0a1.05,1.05,0,0,1,1.06-1h61.67a1,1,0,0,1,1.05,1h0A1.06,1.06,0,0,1,178.79,225.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.91,
    cy: 221.15,
    r: 10.88,
    transform: "translate(-126.19 131.59) rotate(-44.21)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,232h0c3.06-.45,6.7-3,6.7-3a17.46,17.46,0,0,0-3.13-1,1.93,1.93,0,0,1-1.85-2.22,10.23,10.23,0,0,0,2-6.5c-.05-1.74,0-5.14-3.72-5.6h0a8.26,8.26,0,0,0-.88,0h0a8.26,8.26,0,0,0-.88,0h0c-3.69.46-3.66,3.86-3.72,5.6a10.23,10.23,0,0,0,2,6.5,1.93,1.93,0,0,1-1.85,2.22,17.31,17.31,0,0,0-3.12,1S95,231.5,98,232h0a5.43,5.43,0,0,0,.88.08h0a5.33,5.33,0,0,0,.88-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.34,
    cy: 229.55,
    r: 4.3,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,229.31l-.3-1.91h1l-.3,1.91,1.72-.87.32,1-1.89.32,1.35,1.36-.83.61-.89-1.71-.89,1.71-.83-.61,1.35-1.36-1.9-.32.33-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.32,255.21H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h39.28a2,2,0,0,1,2,2h0A2,2,0,0,1,157.32,255.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,260.13H117.12a1.06,1.06,0,0,1-1.06-1.06h0a1.05,1.05,0,0,1,1.06-1.05h81.67a1,1,0,0,1,1.05,1.05h0A1.06,1.06,0,0,1,198.79,260.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.91,
    cy: 256.02,
    r: 10.88,
    transform: "translate(-58.12 30.92) rotate(-13.78)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,266.82h0c3.06-.45,6.7-3,6.7-3a17.46,17.46,0,0,0-3.13-1,1.93,1.93,0,0,1-1.85-2.22,10.23,10.23,0,0,0,2-6.5c-.05-1.74,0-5.14-3.72-5.6h0a8.26,8.26,0,0,0-.88,0h0a8.26,8.26,0,0,0-.88,0h0c-3.69.46-3.66,3.86-3.72,5.6a10.23,10.23,0,0,0,2,6.5,1.93,1.93,0,0,1-1.85,2.22,17.31,17.31,0,0,0-3.12,1s3.63,2.55,6.69,3h0a5.43,5.43,0,0,0,.88.08h0a5.33,5.33,0,0,0,.88-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.91,247.81c-3.91,0-6.65,2.71-7.16,12.48a22.49,22.49,0,0,0,14.32,0C105.56,250.52,102.82,247.81,98.91,247.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,290.08H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h29.28a2,2,0,0,1,2,2h0A2,2,0,0,1,147.32,290.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,295H117.12a1.05,1.05,0,0,1-1.06-1.05h0a1.06,1.06,0,0,1,1.06-1.06H218.79a1.06,1.06,0,0,1,1.05,1.06h0A1,1,0,0,1,218.79,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.91,
    cy: 290.89,
    r: 10.88,
    transform: "translate(-174.81 151.33) rotate(-44.21)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,301.69h0c3.06-.45,6.7-3,6.7-3a17.46,17.46,0,0,0-3.13-1,1.93,1.93,0,0,1-1.85-2.22,10.24,10.24,0,0,0,2-6.51c-.05-1.73,0-5.13-3.72-5.59h0a8.18,8.18,0,0,0-.88-.05h0a8.18,8.18,0,0,0-.88.05h0c-3.69.46-3.66,3.86-3.72,5.59a10.24,10.24,0,0,0,2,6.51,1.93,1.93,0,0,1-1.85,2.22,17.31,17.31,0,0,0-3.12,1s3.63,2.55,6.69,3h0a6.85,6.85,0,0,0,.88.08h0a6.69,6.69,0,0,0,.88-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.34,
    cy: 299.29,
    r: 4.3,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,299l-.3-1.9h1l-.3,1.9,1.72-.86.32,1-1.89.32,1.35,1.35-.83.62-.89-1.71-.89,1.71-.83-.62,1.35-1.35-1.9-.32.33-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,325H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h9.28a2,2,0,0,1,2,2h0A2,2,0,0,1,127.32,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.79,329.86H117.12a1.05,1.05,0,0,1-1.06-1.05h0a1.06,1.06,0,0,1,1.06-1.06h91.67a1.06,1.06,0,0,1,1.05,1.06h0A1,1,0,0,1,208.79,329.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.91,
    cy: 325.76,
    r: 10.88,
    transform: "translate(-199.12 161.21) rotate(-44.21)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,336.56h0c3.06-.46,6.7-3,6.7-3a17.46,17.46,0,0,0-3.13-1,1.94,1.94,0,0,1-1.85-2.22,10.24,10.24,0,0,0,2-6.51c-.05-1.73,0-5.13-3.72-5.59h0a8.18,8.18,0,0,0-.88-.05h0a8.18,8.18,0,0,0-.88.05h0c-3.69.46-3.66,3.86-3.72,5.59a10.24,10.24,0,0,0,2,6.51,1.94,1.94,0,0,1-1.85,2.22,17.31,17.31,0,0,0-3.12,1s3.63,2.54,6.69,3h0a6.79,6.79,0,0,0,.88.07h0a6.65,6.65,0,0,0,.88-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,359.82H118a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h29.28a2,2,0,0,1,2,2h0A2,2,0,0,1,147.32,359.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79,360.62a10.43,10.43,0,0,1-.15,1.78H88.18a10.43,10.43,0,0,1-.15-1.78,10.88,10.88,0,0,1,21.76,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.51,358.69a10.22,10.22,0,0,1-.55,3.71h-8.1a10.22,10.22,0,0,1-.55-3.71c.06-1.73,0-5.13,3.72-5.59h0a7.77,7.77,0,0,1,1.76,0h0C103.49,353.56,103.46,357,103.51,358.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.55,
    cy: 342.71,
    r: 14.37,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.15,
    y: 335.6,
    width: 2.73,
    height: 12.28,
    transform: "translate(307.12 -57.95) rotate(45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.34 345.99 216.28 348.98 219.27 347.92 217.34 345.99",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.08,133.19h49.79a6.5,6.5,0,0,1,6.5,6.5v29.66a6.5,6.5,0,0,1-6.5,6.51h-6.21l5.74,10.88-13.26-10.88H278.08a6.5,6.5,0,0,1-6.5-6.51V139.69A6.5,6.5,0,0,1,278.08,133.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.93,
    y: 143.17,
    width: 46.1,
    height: 2,
    rx: 0.82,
    transform: "translate(605.96 288.35) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.93,
    y: 149.92,
    width: 46.1,
    height: 2,
    rx: 0.82,
    transform: "translate(605.96 301.84) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.93,
    y: 156.66,
    width: 46.1,
    height: 2,
    rx: 0.82,
    transform: "translate(605.96 315.32) rotate(-180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.94,
    y: 163.4,
    width: 25.09,
    height: 2,
    rx: 0.82,
    transform: "translate(626.96 328.81) rotate(-180)",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImport);
export default __webpack_public_path__ + "static/media/contact-import.b3ac6a5212ef546583ea9aab74d4be7d.svg";
export { ForwardRef as ReactComponent };